import { BaseDetail } from 'App/Screens/SubModules/Component'
import fields from 'App/Screens/Job/Accounts/fields'
import { MerchantReference } from './References'

class PageDetail extends BaseDetail {
  constructor(props) {
    super(props)

    this.urlKey = 'module-merchant-account-detail'
    this.title = 'Account'
    this.urlList = '/merchant/account'
    this.headerDescriptions = [
      { key: 'account_code', label: 'Account Code' },
      { key: 'account_name', label: 'Account Name' },
      { key: 'created', label: 'Created', type: 'datetime' },
      { key: 'created_by.username', label: 'Created By' },
      { key: 'modified', label: 'Modified', type: 'datetime' },
      { key: 'modified_by.username', label: 'Modified By' },
    ]
    this.fields = fields
    this.panes = [MerchantReference]
    this.history = {
      url: 'module-merchant-account-history',
      fields: fields,
      urlDetail: "module-merchant-account-history-detail",
      id: props.match.params.id,
      title: 'account_name'
    }
    this.refField = {
      name: 'code',
      type: 'string',
      valLabel: 'account_code',
    }
  }
}

export default PageDetail